export const getFeatureData = (options, entity) => {
    let category = entity.category_list.find((category) => category.code === options[0]);
    let subOption, featureOption, option;
    if (options.length > 1 && category) {
        subOption = category.sub_category_list.find((cat) => cat.code === options[1]);
    }
    else {
        return category;
    }
    if (options.length > 2 && subOption) {
        featureOption = subOption.feature_list.find((feature) => feature.feature_type === options[2]);
    }
    else {
        return subOption;
    }
    if (options.length > 3 && featureOption) {
        option = featureOption.option_list?.find((op) => op === options[3]);
    }
    return featureOption;
};
export const getShowAllData = (options, entity) => {
    let category = entity.category_list.find((category) => category.code === options[0]);
    return category;
};
export const combineMapKey = (...keys) => keys.join('_');
